export const GET_STORAGES = 'GET_STORAGES';
export const GET_STORAGES_SUCCESS = 'GET_STORAGES_SUCCESS';
export const GET_STORAGES_ERROR = 'GET_STORAGES_ERROR';
export const RESET_STORAGES = 'RESET_STORAGES';
